// src/common/hooks/useLegalityModal.ts
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openLegalityModal,
  closeLegalityModal,
  setLegalityScreen,
  selectIsLegalityModalOpen,
  selectLegalityClusterId,
  selectLegalityClusterName,
  selectLegalityScreen,
} from "../../../store/slices/commonModalSlice";
import { LegalityScreens } from "../../types/enums";

export const useLegalityModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsLegalityModalOpen);
  const clusterId = useSelector(selectLegalityClusterId);
  const clusterName = useSelector(selectLegalityClusterName);
  const currentScreen = useSelector(selectLegalityScreen);

  const open = useCallback(
    (
      clusterId: number,
      clusterName?: string,
      initialScreen: LegalityScreens = LegalityScreens.USER_AGREEMENT,
    ) => {
      dispatch(
        openLegalityModal({ clusterId, clusterName, screen: initialScreen }),
      );
    },
    [dispatch],
  );

  const close = useCallback(() => {
    dispatch(closeLegalityModal());
  }, [dispatch]);

  const setScreen = useCallback(
    (screen: LegalityScreens) => {
      dispatch(setLegalityScreen(screen));
    },
    [dispatch],
  );

  return {
    isOpen,
    clusterId,
    clusterName,
    currentScreen,
    open,
    close,
    setScreen,
  };
};
